import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { FormattedMessage, injectIntl } from 'react-intl';
import t from 'tcomb-form';
import objectPath from 'object-path';

const Form = t.form.Form;

class ModalFormStorageAdd extends React.Component {

    constructor(props, context) {

        super(props, context);

        const documentValues = [];
        this.state = {
            formValues: {
                title: '',
                document: '',
                locale: '',
                pricingField:'',
            },
            formOptions: {
                fields: {
                    title: {
                        nullOption: { value: '', text: '-- ' + this.props.intl.formatMessage({id: 'LABEL_SELECT_DOCUMENT'}) + ' --' },
                        label: this.props.intl.formatMessage({id: 'LABEL_INSERT_TITLE'}),
                        error: this.props.intl.formatMessage({id: 'ERROR_REQUIRED'}),
                    },
                    locale: {
                        nullOption: { value: '', text: '-- ' + this.props.intl.formatMessage({id: 'LABEL_SELECT_LANGUAGE'}) + ' --' },
                        label: this.props.intl.formatMessage({id: 'LABEL_LANGUAGE'}),
                        factory: t.form.Select,
                        options: [],
                        error: this.props.intl.formatMessage({id: 'ERROR_REQUIRED'}),
                    },
                    pricingField: {
                        nullOption: { value: '', text: '-- Bitte wählen --' },
                        label: 'Preisfeld Optionen',
                        factory: t.form.Select,
                        options: [],
                        error: this.props.intl.formatMessage({id: 'ERROR_REQUIRED'}),
                    },
                    document: {
                        nullOption: { value: '', text: '-- ' + this.props.intl.formatMessage({id: 'LABEL_SELECT_DOCUMENT'}) + ' --' },
                        label: this.props.intl.formatMessage({id: 'LABEL_SELECT_DOCUMENT_LONG'}),
                        factory: t.form.Select,
                        options: documentValues,
                        error: this.props.intl.formatMessage({id: 'ERROR_REQUIRED'}),
                    }
                }
            },
            formSettings: t.struct({
                title: t.String,
                document: t.String,
                locale: t.String,
                pricingField: t.String,
            }),
            selectedDocument: null,
            selectedLocale: null,
            selectedPricingField: null
        };

        // React components using ES6 classes no longer autobind this to non React methods. In your constructor, add:
        this.saveForm = this.saveForm.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    saveForm(event) {

        event.preventDefault();

        // call getValue() to get the values of the form
        const formValues = this.refs.form.getValue();

        // appPage function from parent component
        let { addStorage } = this.props;

        // if validation fails, value will be null
        if (formValues) {

            const title = formValues.title;
            const document = formValues.document ? formValues.document : this.state.selectedDocument.id;
            const locale = formValues.locale ? formValues.locale : this.state.selectedLocale;
            const pricingField = formValues.pricingField;

            // console.log('ADD storage', title, document, locale);
            addStorage(title, document, locale, pricingField);
        }
    }

    componentWillReceiveProps(nextProps) {
        console.log('componentWillReceiveProps');

        // if component receive new props (after adding a page) update formOptions
        const {documents, selectedDocument} = nextProps;
        const intl = this.props.intl;
        const currentLocale = intl.locale.replace('-', '_'); // de-DE -> de_DE

        let formDefinition = {
            title: t.String,
        };

        let selectedDocumentNew = null;
        let documentValues = [];
        if (!selectedDocument) {
            if (documents.length === 1) {
                selectedDocumentNew = documents[0];
            } else {
                formDefinition.document = t.String;
                documents.map(document => {
                    let documentTitle = objectPath.get(document, 'translationsSorted.' + currentLocale + '.name');
                    if (!documentTitle) {
                        documentTitle = document.name;
                    }
                    documentValues.push({value: document.id, text: documentTitle});
                });
            }
        } else {
            selectedDocumentNew = selectedDocument;
        }

        let selectedDocumentNewTitle = '';
        let localeValues = [];
        let pricingFieldValues=[
            { value: "none", text: "Ohne Preisfeld" },
            { value: "input", text: "Preisfeld mit fixer Preiseingabe" },
            { value: "empty", text: "Preisfeld ohne Preiseingabe (leeres Preisfeld)" }
        ];

        let selectedLocale = null;
        let selectedPricingField = null;
        if (selectedDocumentNew) {

            localeValues = this._getLocales(selectedDocumentNew);
            console.log(localeValues);
            if (localeValues.length === 1) {
                selectedLocale = localeValues[0].value;
                selectedDocumentNewTitle = objectPath.get(selectedDocumentNew, 'translationsSorted.' + selectedLocale + '.name');
                if(!selectedDocumentNewTitle) {
                    selectedDocumentNewTitle = objectPath.get(selectedDocumentNew, 'name');
                }
            } else {
                formDefinition.locale = t.String;
                selectedDocumentNewTitle = objectPath.get(selectedDocumentNew, 'translationsSorted.' + selectedLocale + '.name');
                if(!selectedDocumentNewTitle) {
                    selectedDocumentNewTitle = objectPath.get(selectedDocumentNew, 'name');
                }
            }

            console.log(selectedDocumentNewTitle);



            if (selectedDocumentNewTitle.includes('aufsteller')){
                console.log('aufsteller');
                formDefinition.pricingField = t.String;
            }else{
                console.log('kein aufsteller');
            }

            const formSettings = t.struct(formDefinition);
            const values = t.update(this.state.formValues, {
                title: {'$set': selectedDocumentNewTitle}
            });

            const options = t.update(this.state.formOptions, {
                fields: {
                    document: {
                        options: {'$set': documentValues}
                    },
                    locale: {
                        options: {'$set': localeValues}
                    },
                    pricingField: {
                        options: {'$set': pricingFieldValues}
                    }

                }
            });
            this.setState({
                formValues: values,
                formSettings: formSettings,
                formOptions: options,
                selectedDocument: selectedDocumentNew,
                selectedLocale: selectedLocale
            });
        }
    }

    onChange(value) {
        console.log('onChange');
        const { documents } = this.props;

        let formDefinition = {
            title: t.String,
        };

        if (!this.state.selectedDocument && documents.length > 1) {
            formDefinition.document = t.String;
        }


        let documentValue = null;
        if (value.document) {
            documentValue = value.document;
        } else if (this.state.selectedDocument) {
            documentValue = this.state.selectedDocument.id;
        }

        const selectedDocument = this._getDocument(documents, documentValue);
        const formLocales = this._getLocales(selectedDocument);
        const formPricingField=[
            { value: "none", text: "Ohne Preisfeld" },
            { value: "input", text: "Preisfeld mit fixer Preiseingabe" },
            { value: "empty", text: "Preisfeld ohne Preiseingabe (leeres Preisfeld)" }
        ];

        console.log('selectedDocument');
        console.log(selectedDocument);

        let selectedLocale = null;
        let valueOptions = [];
        if (formLocales.length === 1) {
            selectedLocale = formLocales[0].value;
        } else if (formLocales.length > 1) {
            formDefinition.locale = t.String;
        }

        if (selectedDocument.name.includes('aufsteller')){
            formDefinition.pricingField = t.String;
        }

        const options = t.update(this.state.formOptions, {
            fields: {
                locale: {
                    options: { '$set': formLocales }
                },
                pricingField: {
                    options: {'$set': formPricingField}
                }
            }
        });

        const formSettings = t.struct(formDefinition);

        this.setState({
            formOptions: options,
            formValues: value,
            formSettings: formSettings,
            selectedLocale: selectedLocale
        });
    }

    _getDocument(documents, documentId) {
        let document = null;
        documents.map(entry => {
            if (entry.id.toString() === documentId.toString()) {
                document = entry;
            }
        });

        return document;
    }

    _getLocales(document) {
        let locales = [];
        if (document.translationsSorted) {
            Object.keys(document.translationsSorted).map(locale => {
                locales.push({value: locale, text: this.props.intl.formatMessage({id: 'LANGUAGE_' + locale})})
            });
        }

        return locales;
    }

    render() {

        const { isOpenModal, closeModal } = this.props;

        return (
            <Modal
                className="Modal__Bootstrap modal-dialog"
                closeTimeoutMS={150}
                isOpen={isOpenModal}
                onRequestClose={() => closeModal()}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={() => closeModal()}>
                            <span aria-hidden="true">&times;</span>
                            <span className="sr-only"><FormattedMessage id="LABEL_CLOSE"/></span>
                        </button>
                        <h4 className="modal-title"><FormattedMessage id="LABEL_CREATE_NEW_STORAGE"/></h4>
                    </div>

                    <div className="modal-body">
                        <form className="form-horizontal" role="form" onSubmit={event => this.saveForm(event)}>
                            <Form
                                ref="form"
                                type={ this.state.formSettings }
                                value={ this.state.formValues }
                                options={ this.state.formOptions }
                                onChange={ this.onChange }
                            />
                        </form>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" onClick={() => closeModal()}><FormattedMessage id="LABEL_CANCEL"/></button>
                        <button type="button" className="btn btn-primary" onClick={event => this.saveForm(event)}><FormattedMessage id="LABEL_TO_CONFIGURATOR"/></button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default connect(state => ({ app: state.app }))(injectIntl(ModalFormStorageAdd));



// WEBPACK FOOTER //
// ./src/js/components/forms/ModalFormStorageAdd.react.jsx